import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-4 py-16 sm:py-20" aria-labelledby="faq-heading" data-id="element-112" data-mp="2z2z18ykci74t">
      <div className="mx-auto max-w-3xl" data-id="element-113" data-mp="3mt31cvybror2">
        <p className="text-center font-display text-sm font-extrabold uppercase tracking-widest text-gold-600" data-id="element-114" data-mp="3mu4bmy7io77q">FAQ</p>
        <h2 id="faq-heading" className="mt-3 text-center font-display text-[1.7rem] font-black leading-tight text-navy-950 sm:text-4xl" data-id="element-115" data-mp="3rr4gx6wjl5xs">
          Frequently Asked Questions
        </h2>

        <div className="mt-10 space-y-3" data-id="element-116" data-mp="3i0ib24emntsa">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl bg-white" data-id="element-117" data-mp="ecztoq77q02q" data-mpi={i}>
                <h3 data-id="element-118" data-mp="ef2tg1y637kn">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-display text-[15px] font-extrabold text-navy-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-gold-500 sm:text-base" data-id="element-119" data-mp="20qq9tfd0e8s8">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-gold-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-120" data-mp="2eidd3z5dchki" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-121" data-mp="2oege31ohia5v">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-122" data-mp="z3h23djo3k8m">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-ink/80" data-id="element-123" data-mp="1squ5a46ccwwy">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-10" data-id="element-124" data-mp="22p1e1zqh88nv">
          <CTAButton label="I’m ready — get my Roadmap™" sublabel="One-time payment of $27" data-id="element-125" data-mp="26qmutw64t73c" />
        </div>
      </div>
    </section>;
}